"use client";

import React, { ReactNode } from "react";

interface ContainerGlobProps {
  children: ReactNode;
  className?: string;
}

export const ContainerGlob: React.FC<ContainerGlobProps> = ({
  children,
  className = "",
}) => {
  return (
    <div
      className={`mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 py-2 ${className}`}
    >
      {children}
    </div>
  );
};

export default ContainerGlob;
